var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-card',[_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('thanks.header')))]),_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t('thanks.subheader')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }